<template>
   <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
        <div class="card">
             <div class="card-header card-header-flex">
                <div class="d-flex flex-column justify-content-center mr-auto">
                    <h5 class="mb-0">สเตทเม้นสร้างมือ</h5>
                </div>
                <a-tabs v-model="setTab" defaultActiveKey="1" @change="useActive" class="kit-tabs">
                    <a-tab-pane tab="สเตทเม้น" key="1" />
                    <a-tab-pane tab="สร้างสเตทเม้น" key="2" />
                </a-tabs>
            </div>
            <div class="card-body">
                <component @set-start="setStart" v-bind:is="component" v-bind="setData" />
            </div>
        </div>
    </div>
</template>

<script>
import formsCreated from './formsCreated'
import tables from './table'
export default {
  components: {
    formsCreated,
    tables,
  },
  data() {
    return {
      setTab: '1',
      isReload: false,
      component: 'tables',
    }
  },
  computed: {
    setData: function () {
      return {
        isReload: this.isReload,
      }
    },
  },
  methods: {
    useActive(e) {
      if (e === '1') this.component = 'tables'
      if (e === '2') this.component = 'formsCreated'
    },
    setStart() {
      this.setTab = '1'
      this.component = 'tables'
    },
  },
}
</script>

<style>

</style>
